import { render, staticRenderFns } from "./arbitration_detail.vue?vue&type=template&id=4f90aa0a&scoped=true"
import script from "./arbitration_detail.vue?vue&type=script&lang=js"
export * from "./arbitration_detail.vue?vue&type=script&lang=js"
import style0 from "./arbitration_detail.vue?vue&type=style&index=0&id=4f90aa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f90aa0a",
  null
  
)

export default component.exports